export default __webpack_public_path__ + "static/media/gas.e909f576.png";